import * as Yup from 'yup';
import { ValidationRules } from "helpers/createFormConfig";
import { addressValidationRules } from 'features/new-actor/form/validation-rules/addressValidationRules';
import { bankAccountsArraySchema } from 'back-office/shared/components/bank-accounts/bankAccountsValidation';
import { PlateformeFormValues } from "./PlateformeFormValues";
import { PlateformeFormFieldNames } from './PlateformeFormFieldNames';
import { themeValidationRules } from './themeValidationRules';

export const plateformeValidationRules: ValidationRules<keyof PlateformeFormValues> = {
  ...addressValidationRules,
  [PlateformeFormFieldNames.Name]: Yup.string()
    .required('Le nom est requis')
    .min(2, 'Le nom doit contenir au moins 2 caractères'),
  // Optionnel : si vide, le serveur génère un code (C{année}-{n°}).
  [PlateformeFormFieldNames.Code]: Yup.string(),
  [PlateformeFormFieldNames.LogoFile]: Yup.mixed()
    .nullable(),
  [PlateformeFormFieldNames.MinimalLogoFile]: Yup.mixed()
    .nullable(),
  // Personne morale corporate principale
  [PlateformeFormFieldNames.Phone]: Yup.string()
    .required('Le téléphone est requis')
    .matches(/^(?:(?:\+|00)33|0)\s*[1-9](?:[\s.-]*\d{2}){4}$/, 'Format de téléphone invalide'),
  // SIREN (entité légale, 9 chiffres) — cas particulier de la corporate.
  [PlateformeFormFieldNames.RegistrationNumber]: Yup.string()
    .required('Le numéro SIREN est requis')
    .matches(/^\d{9}$/, 'Le SIREN doit contenir 9 chiffres'),
  [PlateformeFormFieldNames.Capital]: Yup.number()
    .typeError('Le capital doit être un nombre')
    .required('Le capital est requis')
    .min(0, 'Le capital doit être positif'),
  [PlateformeFormFieldNames.RcsCity]: Yup.string()
    .required('La ville RCS est requise'),
  [PlateformeFormFieldNames.RcsNumber]: Yup.string()
    .required('Le numéro RCS est requis'),
  // Une corporate n'est pas un intermédiaire immatriculé : ORIAS optionnel.
  // ORIAS obligatoire pour la nature Corporate (compagnie, acteur de l'assurance)
  // — même règle que le pipeline back (OriasRequis).
  [PlateformeFormFieldNames.OriasNumber]: Yup.string()
    .required("Le numéro ORIAS est requis pour la personne morale gérante"),
  [PlateformeFormFieldNames.Rcp]: Yup.string()
    .nullable()
    .notRequired(),
  [PlateformeFormFieldNames.Email]: Yup.string()
    .required("L'email du compte corporate est requis")
    .email('Format email invalide'),
  [PlateformeFormFieldNames.AdditionalRoles]: Yup.array().of(Yup.string()),
  [PlateformeFormFieldNames.SousNature]: Yup.string()
    .oneOf(['', 'MUT', 'REA'], 'Type de compagnie invalide'),
  [PlateformeFormFieldNames.BankAccounts]: bankAccountsArraySchema,
  ...themeValidationRules
};
